import React, { Component } from 'react';
import Header from '../../header/header';
import Aside from '../../aside';
import './pageAdmin.css';
import TestList from '../../testList';

class PageAdmin extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="admin-container">
          <TestList />
          <Aside />
        </div>
      </React.Fragment>
    );
  }
}

export default PageAdmin;
